const returnToday = () => {
    let today = new Date();
    let year = today.getFullYear()
    let month = today.getMonth()+1
    let date = today.getDate()
    let transToday = `${year}-${month>9?month:'0'+month}-${date>9?date:'0'+date}`;
    // console.log("오늘은",transToday)
    return transToday
}
export default returnToday;